import React, { useState } from 'react';
import AuditFileUploader from './AuditFileUploader';
import AuditMessage from './AuditMessage';

interface Props {
  nomeArquivoAtual: string;
  acceptedExtensions: string[];
  substituindo: boolean;
  onCancelar: () => void;
  onConfirmar: (novoArquivo: File) => void;
}

// Épico "Mensagens, Feedbacks e Gestão de Arquivos", seções 35-39 — Substituir é uma ação
// DISTINTA de Adicionar novo arquivo (CA36): atualiza o arquivo vigente, mantendo a versão
// anterior no histórico (ver AuditFileHistory), em vez de criar um registro novo e independente.
const AuditReplaceFileModal: React.FC<Props> = ({
  nomeArquivoAtual,
  acceptedExtensions,
  substituindo,
  onCancelar,
  onConfirmar,
}) => {
  const [novoArquivo, setNovoArquivo] = useState<File | null>(null);

  return (
    <div className='audit-modal-backdrop' onClick={substituindo ? undefined : onCancelar}>
      <div className='audit-modal' onClick={(e) => e.stopPropagation()} role='dialog' aria-modal='true'>
        <div className='audit-modal-header'>
          <h4>Substituir arquivo</h4>
          {!substituindo && <button type='button' className='btn-close' aria-label='Fechar' onClick={onCancelar} />}
        </div>
        <div className='audit-modal-body'>
          <p>
            Deseja substituir o arquivo atual (<strong>{nomeArquivoAtual}</strong>) por uma nova versão? O arquivo
            atual permanecerá disponível no histórico até a confirmação da nova versão.
          </p>
          <AuditFileUploader
            acceptedExtensions={acceptedExtensions}
            multiple={false}
            disabled={substituindo}
            onFilesSelected={(files) => setNovoArquivo(files[0] ?? null)}
          />
          {substituindo && (
            <div className='mt-3'>
              <AuditMessage type='INFO' title='Enviando nova versão' message='Aguarde enquanto o arquivo é enviado.' />
            </div>
          )}
        </div>
        <div className='audit-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={substituindo} onClick={onCancelar}>
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-sm btn-primary'
            disabled={substituindo || !novoArquivo}
            onClick={() => novoArquivo && onConfirmar(novoArquivo)}
          >
            {substituindo && <span className='spinner-border spinner-border-sm me-2' />}
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuditReplaceFileModal;
